import { render, staticRenderFns } from "./SoundController.vue?vue&type=template&id=674cfd8f&scoped=true&"
import script from "./SoundController.vue?vue&type=script&lang=js&"
export * from "./SoundController.vue?vue&type=script&lang=js&"
import style0 from "./SoundController.vue?vue&type=style&index=0&id=674cfd8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674cfd8f",
  null
  
)

export default component.exports